<template>
  <v-container fluid>
    <h2 class="mt-5 mb-6">{{ $t('shifting') }}</h2>
    <v-card>
      <v-tabs v-model="tabActive" background-color="white" color="primary" left @change="changeActiveTab($event)">
        <v-tab>{{ $t('schedule_shifting') }}</v-tab>
        <v-tab>{{ $t('manage_shift_code') }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tabActive" touchless>
        <v-tab-item>
          <v-container fluid>
            <Work v-if="tabActive == 0"></Work>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid>
            <Time v-if="tabActive == 1"></Time>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
// import axios from "axios";
import Work from "./components/Work";
import Time from "./components/Time";
export default {
  name: "schedule",
  data() {
    return {
      tabActive: 0
    };
  },
  methods: {
    changeActiveTab(e) {
      this.tabActive = e
    }
  },
  created() { },
  components: {
    Work,
    Time,
  }
};
</script>